import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { getUser } from "../utilities/users-service";
import Main from "../components/Main/Main";
import Footer from "../components/Footer/Footer";
import NavBar from "../components/NavBar/NavBar";

export default function App() {
  const [user, setUser] = useState(getUser());
  const location = useLocation();

  // Drop the logged-in UI when the token expires mid-session
  // (getUser returns null and clears localStorage once the token is expired)
  useEffect(() => {
    const interval = setInterval(() => {
      setUser((current) => (current && !getUser() ? null : current));
    }, 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const isStampShow =
    /^\/stamps\/[^/]+$/.test(location.pathname) &&
    !location.pathname.endsWith("/edit") &&
    !location.pathname.endsWith("/new");

  return (
    <div
      className={`text-left font-sans ${isStampShow ? "bg-neutral-950" : "bg-background"}`}
    >
      <NavBar user={user} setUser={setUser} />
      <Main user={user} setUser={setUser} />
      {/* <Footer /> */}
    </div>
  );
}
